import AppHeader from '../../components/AppHeader/AppHeader'
import { AppState } from '../../redux/store'
import Modal from '../../components/Modal/Modal'
import Pdp from './Pdp/Pdp'
import { PlpContainer } from './Plp.style'
import PlpProductCard from './PlpProductCard/PlpProductCard'
import { useGetClusterUnique } from '../../api/BrandsApi'
import { useSelector } from 'react-redux'
import { useState } from 'react'

type Upc = string

const Plp: React.FC = () => {
	const currentCluster = useSelector((state: AppState) => state.cluster.current)

	if (!currentCluster) {
		throw new Error('Cluster not found')
	}

	const [selectedUpc, setSelectedUpc] = useState<Upc | null>(null)

	const selectedCluster = useGetClusterUnique(currentCluster)
	const clusterProducts = selectedCluster && selectedCluster.data?.products
	const openedProduct = clusterProducts?.find(
		product => product.UPC === selectedUpc,
	)

	return (
		<>
			<AppHeader plpCluster={selectedCluster.data} />
			<PlpContainer>
				{clusterProducts &&
					clusterProducts.map(product => (
						<PlpProductCard
							setSelectedUpc={setSelectedUpc}
							key={product.UPC}
							product={product}
						/>
					))}
			</PlpContainer>
			<Modal onClose={() => setSelectedUpc(null)} visible={!!selectedUpc}>
				<Pdp product={openedProduct} />
			</Modal>
		</>
	)
}

export default Plp
